import { render } from "./BaseVideoMessage.vue?vue&type=template&id=477db410"
import script from "./BaseVideoMessage.vue?vue&type=script&lang=js"
export * from "./BaseVideoMessage.vue?vue&type=script&lang=js"

import "./BaseVideoMessage.vue?vue&type=style&index=0&id=477db410&lang=css"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__